import React, { useEffect, useState } from "react";
import {
  Grid,
  Typography,
  TextareaAutosize,
  Card,
  InputAdornment,
  Box,
} from "@mui/material";
import FormControl from "@mui/material/FormControl";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { ValidationError, object, string, number } from "yup";
import dayjs from "dayjs";
import commonStyles from "../../../App.module.scss";
import constants from "../../../config/constants.json";
import styles from "../devoteeService.module.scss";
import { isBoolean, isNil } from "lodash";
import deleteIcon from "../../../assets/svg/delete_outline.svg";
import IconButton from "@mui/material/IconButton";
import cartIcon from "../../../assets/svg/Cart.svg";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import {
  CustomSelect,
  CustomMenuItem,
  CustomRequiredInputLabel,
  CustomRadioButton,
  StyledDateContainer,
  CustomDatePicker,
  CustomCalendarTodayOutlinedIcon,
  CustomLeftIcon,
  CommonOutlinedButton,
  CommonButton,
  CustomBadge,
  CustomTextFeild,
  CustomInputLabel,
  formatAmount,
} from "../../common/StyledComponents/StyledFields";
import ModeofPayment from "../../common/modeOfPayment/modeOfPayment";
import {
  apiRequest,
  catchErrorMessageHandler,
  getDevoteeId,
  getUserDetails,
  getUserName,
  getUserSelectedRole,
} from "../../../infrastructure/backendService";
import CloseIcon from "@mui/icons-material/Close";
import apiPath from "../../../config/apiPaths.json";
import {
  VastrasListProps,
  cartItemListProps,
  deitiesListvastras,
} from "../../../infrastructure/GlobalContextProvider";
import toast, { Toaster } from "react-hot-toast";
import LOCALE from "../../../config/en-us.json";
import { ClipLoader } from "react-spinners";
import SuccessPopup from "../../devotee/donation/successPopup";
import ErrorPopup from "../../common/ErrorPopup";
import { CartComponent } from "../../common/cartItemsComponent/cartComponent";

interface VastrasProps {
  showHeaders?: boolean;
  username: string;
  onBackClick?: () => void;
}

interface FormDataTypes {
  id?: number | undefined | null;
  username: string;
  purposeOfVastra: string;
  vastraCategory: string;
  deity: string;
  dateOfAdornment: string;
  amountinDollars: string;
  vastraExchange: string;
  description: string;
}

interface TableDataTypes {
  id?: number;
  username: string;
  vastraName: string;
  vastraCategory: string;
  deityName: string;
  dateOfAdornment: string;
  amountinDollars: number;
  vastraExchange: string;
  description: string;
}

type ErrorDataTypes = {
  username: string;
  purposeOfVastra: string;
  vastraCategory: string;
  deity: string;
  dateOfAdornment: string;
  amountinDollars: string;
  vastraExchange: string;
  description: string;
  vigrahaType: string;
  vastraTag: string;
  tangibleAmount: string;
};

const Vastaras = (props: VastrasProps) => {
  const [formData, setFormData] = useState({
    username: props.username || "",
    purposeOfVastra: "",
    deity: "",
    vastraCategory: "",
    vastraExchange: "",
    dateOfAdornment: "",
    description: "",
    amountinDollars: 0,
    vigrahaType: "",
    vastraTag: "",
    tangibleAmount: 0,
  });
  const [errorMessage, setErrorMessage] = useState<ErrorDataTypes>({
    username: "",
    purposeOfVastra: "",
    deity: "",
    vastraCategory: "",
    vastraExchange: "",
    dateOfAdornment: "",
    amountinDollars: "",
    description: "",
    vigrahaType: "",
    vastraTag: "",
    tangibleAmount: "",
  });
  const [totalDonationAmount, setTotalDonationAmount] = useState<number>(0);
  const [selectedId, setSelectedId] = useState<number | null | undefined>(null);
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [showList, setShowList] = useState<boolean>(false);
  const [vastrasList, setVastrasList] = useState<VastrasListProps[]>([]);
  const [deitiesList, setDeitiesList] = useState<deitiesListvastras[]>([]);
  const [cartItemsList, setcartItemsList] = useState<cartItemListProps[]>([]);
  const [isDatePickerOpen, setDatePickerOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [resData, setResData] = useState<any>([]);
  const hasManagerLevelRole = constants.showDashBoardForRoles.includes(
    getUserSelectedRole() || ""
  );

  const getHeaders = (): boolean => {
    if (
      !isNil(props.showHeaders) &&
      isBoolean(props.showHeaders) &&
      props.showHeaders === false
    ) {
      return false;
    } else {
      return true;
    }
  };

  useEffect(() => {
    apiRequest({
      method: "GET",
      endpoint: apiPath.vastrasList,
      includeToken: true,
    })
      .then((res) => {
        setVastrasList(res.data);
      })
      .catch((err) => {
        console.log(err);
        toast.custom(
          <ErrorPopup
            showMessage={catchErrorMessageHandler(err)}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
          />,
          {
            duration: constants.TOAST_POPUP_DURATION,
          }
        );
      });
  }, []);

  useEffect(() => {
    apiRequest({
      method: "GET",
      endpoint: apiPath.deitiesList,
      includeToken: true,
    })
      .then((res) => {
        setDeitiesList(res.data);
      })
      .catch((err) => {
        console.log(err);
        toast.custom(
          <ErrorPopup
            showMessage={catchErrorMessageHandler(err)}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
          />,
          {
            duration: constants.TOAST_POPUP_DURATION,
          }
        );
      });
  }, []);

  useEffect(() => {
    getCartItems();
  }, []);

  const getCartItems = () => {
    apiRequest({
      method: "GET",
      endpoint: apiPath.cartItems,
      includeToken: true,
      params: {
        username: props.username,
      },
    })
      .then((res) => {
        setcartItemsList(res.data.bookedItemInCart);
        setTotalDonationAmount(res.data.totalAmount);
        setShowList(false);
      })
      .catch((err) => {
        console.log(err);
        setShowList(false);
        toast.custom(
          <ErrorPopup
            showMessage={catchErrorMessageHandler(err)}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
          />,
          {
            duration: constants.TOAST_POPUP_DURATION,
          }
        );
      });
  };

  const validationSchema = object().shape({
    username: string().required("Name is required"),
    purposeOfVastra: string().required("Purpose Of Vastra is required"),
    dateOfAdornment: string().required("Adornment Date is required"),
    vastraCategory: string().required("Vastra Category is required"),
    vastraExchange: string().required("Vastra Exchange is required"),
    description: string().required("Description is required"),
    deity: string().required("Deity is required"),
    vigrahaType: string().required("Vigraha Type is Required"),
    // vastraTag: string().required("Vastra Tag is Required"),
    tangibleAmount: string().required("Tangible Amount is Required"),
    amountinDollars: number()
    .required("Donation amount is required")
    .min(1, "Minimum donation amount is 1")
    .transform((value, originalValue) => {
      return originalValue === "" ? undefined : value;
    }),
  });

  const getDonationAmount = (field: string, value: string) => {
    const filterRequiredDonationAmt = resData.find((item: any) => {
      if (field === "purposeOfVastra") {
        return (
          item.vastraPurposeId === value &&
          item.vastraCategory === formData.vastraCategory &&
          item.vastraExchange === formData.vastraExchange
        );
      } else if (field === "vastraCategory") {
        return (
          item.vastraPurposeId === formData.purposeOfVastra &&
          item.vastraCategory === value &&
          item.vastraExchange === formData.vastraExchange
        );
      } else if (field === "vastraExchange") {
        return (
          item.vastraPurposeId === formData.purposeOfVastra &&
          item.vastraCategory === formData.vastraCategory &&
          item.vastraExchange === value
        );
      }
      return false;
    });

    if (filterRequiredDonationAmt) {
      return filterRequiredDonationAmt;
    } else {
      // Handle the case where no matching item is found
      return { suggestedDonation: 0, tangibleAmount: 0 }; // Or any default value you want to set
    }
  };

  const getVastrasAmount = () => {
    apiRequest({
      method: "GET",
      endpoint: `${apiPath.vastraDetailsAPI}`,
      includeToken: true,
    })
      .then((res) => {
        setResData(res.data.content);
      })
      .catch((err) => {
        console.log(err);
        toast.custom(
          <ErrorPopup
            showMessage={catchErrorMessageHandler(err)}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
          />,
          {
            duration: constants.TOAST_POPUP_DURATION,
          }
        );
      });
  };

  const addToCartApiCall = () => {
    const reqBody = {
      onBehalfOfUsername: formData.username,
      amount: formData.amountinDollars,
      donationsPurposeId: formData.purposeOfVastra,
      description: formData.description,
      dateOfDonation: formData.dateOfAdornment,
      enteredBy: formData.username,
      deityId: formData.deity,
      vastraCategory: formData.vastraCategory,
      vastraExchange: formData.vastraExchange,
      tangibleValue: formData.tangibleAmount,
      vastraAdditionalMetadata: {
        vastratag: formData.vastraTag,
        vigrahatype: formData.vigrahaType,
      },
    };
    setLoading(true);
    apiRequest({
      method: "POST",
      endpoint: apiPath.addVastrasCart,
      includeToken: true,
      body: JSON.stringify(reqBody),
    })
      .then((res) => {
        setLoading(false);
        setFormData({
          username: props.username || "",
          purposeOfVastra: "",
          deity: "",
          vastraCategory: "",
          vastraExchange: "",
          dateOfAdornment: "",
          description: "",
          amountinDollars: 0,
          vigrahaType: "",
          vastraTag: "",
          tangibleAmount: 0,
        });
        getCartItems();
        // toast.custom(<ToastSuccess message={LOCALE.ITEM_ADDED} />)
        toast.custom(
          <SuccessPopup
            headerMessage="Items Added"
            showMessage={LOCALE.ITEM_ADDED}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
            
          />,
          {
            duration: constants.TOAST_POPUP_DURATION,
          }
        );
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
        toast.custom(
          <ErrorPopup
            showMessage={catchErrorMessageHandler(err)}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
          />,
          {
            duration: constants.TOAST_POPUP_DURATION,
          }
        );
      });
  };

  const handleAdd = async () => {
    const errors: ErrorDataTypes = {
      username: "",
      purposeOfVastra: "",
      dateOfAdornment: "",
      amountinDollars: "",
      vastraCategory: "",
      vastraExchange: "",
      deity: "",
      description: "",
      vigrahaType: "",
      vastraTag: "",
      tangibleAmount: "",
    };
    try {
      // Validate the form data against the validation schema
      await validationSchema.validate(formData, { abortEarly: false });
      // If validation passes, you can submit the form
      setErrorMessage(errors);
      // Call your API or perform other actions here
      addToCartApiCall();
      // handleCancel();
    } catch (error) {
      // Handle validation errors

      if (error instanceof ValidationError) {
        error.inner.forEach((e) => {
          if (e.path) {
            errors[e.path as keyof ErrorDataTypes] = e.message;
          }
        });
      }
      setErrorMessage(errors);
    }
  };

  const handleFieldChange = (field: string, value: any) => {
    if (field === "vastraCategory" || field === "vastraExchange" || field === "purposeOfVastra") {
      setFormData({
        ...formData,
        [field]: value,
        amountinDollars: getDonationAmount(field, value).suggestedDonation,
        tangibleAmount: getDonationAmount(field, value).tangibleAmount,
      });
    } else {
      setFormData({
        ...formData,
        [field]: value,
      });
    }
  };

  useEffect(() => {
    getVastrasAmount();
  }, []);

  const PurposeOfVastrasList = (): React.ReactElement => {
    return (
      <FormControl className={styles.dropDowns}>
        <CustomSelect
          IconComponent={KeyboardArrowDownIcon}
          placeholder="Select Pooja Location"
          value={formData.purposeOfVastra}
          defaultValue=""
          id="purposeOfVastra"
          onChange={(e) => {
            handleFieldChange("purposeOfVastra", e.target.value);
            setErrorMessage({ ...errorMessage, purposeOfVastra: "", amountinDollars: "", tangibleAmount: "" });
            // getVastrasAmount(e.target.value);
          }}
          MenuProps={{
            PaperProps: {
              sx: {
                border: "1px solid #F05802",
                "& ul": {
                  paddingTop: 0,
                  paddingBottom: 0,
                  overflowY: "auto",
                  minHeight: "auto",
                  maxHeight: "300px",
                  "&::-webkit-scrollbar": {
                    width: "8px",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    background: "#F3C539",
                    borderRadius: "6px",
                  },
                },
              },
            },
          }}
          className={
            errorMessage.purposeOfVastra
              ? styles.errorTextField
              : styles.textField
          }
        >
          {vastrasList?.map((item: VastrasListProps, index: number) => (
            <CustomMenuItem key={index} value={item.vastraPurposeId}>
              {item.vastraName}
            </CustomMenuItem>
          ))}
        </CustomSelect>

        {errorMessage.purposeOfVastra ? (
          <Typography sx={{ color: "red", fontSize: "12px" }}>
            {errorMessage.purposeOfVastra}
          </Typography>
        ) : (
          ""
        )}
      </FormControl>
    );
  };

  const VastracategoryDropdown = (): React.ReactElement => {
    return (
      <>
        <div className={styles.dropDowns} >
          {CustomRequiredInputLabel("Vastra Category", true)}
          <CustomRadioButton
            id="vastraCategoryOwn"
            checked={formData.vastraCategory === "Own"}
            onChange={() => {
              setErrorMessage({ ...errorMessage, vastraCategory: "", amountinDollars: "", tangibleAmount: "" });
              handleFieldChange("vastraCategory", "Own");
            }}
          />

          <label className={styles.label}>Own</label>
          <CustomRadioButton
          id="vastraCategoryTemple"
            checked={formData.vastraCategory === "Temple"}
            onChange={() => {
              setErrorMessage({ ...errorMessage, vastraCategory: "", amountinDollars: "", tangibleAmount: "" });
              handleFieldChange("vastraCategory", "Temple");
            }}
          />
          <label className={styles.label}>Temple</label>
        </div>
        {errorMessage.vastraCategory ? (
          <Typography sx={{ color: "red", fontSize: "12px" }}>
            {errorMessage.vastraCategory}
          </Typography>
        ) : (
          ""
        )}
      </>
    );
  };

  const VastraExchangeCheckBoxes = (): React.ReactElement => {
    return (
      <>
        <div className={styles.dropDowns}>
          {CustomRequiredInputLabel("Vastra Exchange", true)}
          <CustomRadioButton
          id="vastraExchangeReturn"
            checked={formData.vastraExchange === "Return"}
            onChange={() => {
              setErrorMessage({ ...errorMessage, vastraExchange: "", amountinDollars: "", tangibleAmount: "" });
              handleFieldChange("vastraExchange", "Return");
            }}
          />
          <label className={styles.label}>Return</label>
          <CustomRadioButton
          id="vastraExchangeNoReturn"
            checked={formData.vastraExchange === "No Return"}
            onChange={() => {
              setErrorMessage({ ...errorMessage, vastraExchange: "", amountinDollars: "", tangibleAmount: "" });
              handleFieldChange("vastraExchange", "No Return");
            }}
          />
          <label className={styles.label}>No Return</label>
        </div>
        {errorMessage.vastraExchange ? (
          <Typography sx={{ color: "red", fontSize: "12px" }}>
            {errorMessage.vastraExchange}
          </Typography>
        ) : (
          ""
        )}
      </>
    );
  };

  const DeityDropdown = (): React.ReactElement => {
    return (
      <FormControl className={styles.dropDowns}>
        <CustomSelect
          IconComponent={KeyboardArrowDownIcon}
          placeholder="Select Pooja Location"
          value={formData.deity}
          defaultValue=""
          id="deity"
          onChange={(e) => {
            handleFieldChange("deity", e.target.value);
            setErrorMessage({ ...errorMessage, deity: "" });
          }}
          MenuProps={{
            PaperProps: {
              sx: {
                border: "1px solid #F05802",
                "& ul": {
                  paddingTop: 0,
                  paddingBottom: 0,
                  overflowY: "auto",
                  minHeight: "auto",
                  maxHeight: "300px",
                  "&::-webkit-scrollbar": {
                    width: "8px",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    background: "#F3C539",
                    borderRadius: "6px",
                  },
                },
              },
            },
          }}
          className={
            errorMessage.deity ? styles.errorTextField : styles.textField
          }
        >
          {deitiesList?.map((item: deitiesListvastras, index: number) => (
            <CustomMenuItem key={index} value={item.id}>
              {item.deityName}
            </CustomMenuItem>
          ))}
        </CustomSelect>
        {errorMessage.deity ? (
          <Typography sx={{ color: "red", fontSize: "12px" }}>
            {errorMessage.deity}
          </Typography>
        ) : (
          ""
        )}
      </FormControl>
    );
  };

  const VigrahaTypeList = [
    {
      type: "Moola Murthy",
    },
    {
      type: "Utsava Murthy",
    },
  ];

  const VigrahaDropdown = (): React.ReactElement => {
    return (
      <FormControl className={styles.dropDowns}>
        <CustomSelect
          IconComponent={KeyboardArrowDownIcon}
          placeholder="Select Pooja Location"
          value={formData.vigrahaType}
          defaultValue=""
          id="vigrahaType"
          onChange={(e) => {
            handleFieldChange("vigrahaType", e.target.value);
            setErrorMessage({ ...errorMessage, vigrahaType: "" });
          }}
          MenuProps={{
            PaperProps: {
              sx: {
                border: "1px solid #F05802",
                "& ul": {
                  paddingTop: 0,
                  paddingBottom: 0,
                  overflowY: "auto",
                  minHeight: "auto",
                  maxHeight: "300px",
                  "&::-webkit-scrollbar": {
                    width: "8px",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    background: "#F3C539",
                    borderRadius: "6px",
                  },
                },
              },
            },
          }}
          className={
            errorMessage.vigrahaType ? styles.errorTextField : styles.textField
          }
        >
          {VigrahaTypeList?.map((item) => (
            <CustomMenuItem value={item.type}>{item.type}</CustomMenuItem>
          ))}
        </CustomSelect>
        {errorMessage.vigrahaType ? (
          <Typography sx={{ color: "red", fontSize: "12px" }}>
            {errorMessage.vigrahaType}
          </Typography>
        ) : (
          ""
        )}
      </FormControl>
    );
  };

  const handleDateChange = (field: keyof FormDataTypes, value: any) => {
    const formattedDate = dayjs(value, "MM-DD-YYYY");
    setFormData({
      ...formData,
      [field]: formattedDate.isValid()
        ? formattedDate.format("MM-DD-YYYY")
        : "",
    });
  };

  const handleDatePickerClick = () => {
    setDatePickerOpen(true);
  };

  useEffect(() => {
    setDatePickerOpen(false);
  }, [formData.dateOfAdornment]);

  const BasicDatePicker = (): React.ReactElement => {
    return (
      <div>
        <StyledDateContainer onClick={handleDatePickerClick} id="dateOfAdornment">
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DemoContainer components={["DateTimePicker"]}>
              <CustomDatePicker
                open={isDatePickerOpen}
                onClose={() => setDatePickerOpen(false)}
                slots={{
                  openPickerIcon: CustomCalendarTodayOutlinedIcon,
                }}
                slotProps={{
                  inputAdornment: {
                    position: "end",
                  },
                }}
                format="MM-DD-YYYY"
                value={
                  formData.dateOfAdornment
                    ? dayjs(formData.dateOfAdornment, "MM-DD-YYYY")
                    : ""
                }
                disablePast
                onChange={(value) => {
                  const selectedDate = dayjs(value as string, "MM-DD-YYYY");
                  const currentDate = dayjs();
                  if (selectedDate.isBefore(currentDate, "day")) {
                    setErrorMessage({
                      ...errorMessage,
                      dateOfAdornment: "Please select a future date.",
                    });
                  } else {
                    handleDateChange("dateOfAdornment", value);
                    setErrorMessage({ ...errorMessage, dateOfAdornment: "" });
                  }
                }}
                className={
                  errorMessage.dateOfAdornment
                    ? styles.errorTextField
                    : styles.textField
                }
              />
            </DemoContainer>
          </LocalizationProvider>
          {errorMessage.dateOfAdornment ? (
            <Typography sx={{ color: "red", fontSize: "12px" }}>
              {errorMessage.dateOfAdornment}
            </Typography>
          ) : (
            ""
          )}
        </StyledDateContainer>
      </div>
    );
  };

  const navigateBack = () => {
    getCartItems();
  };

  const openConfirmPopUp = (id: number | undefined | null) => {
    setSelectedId(id);
    setIsOpen(true);
  };

  const tableDataComponent = () => {
    return (
      <div>
        <div className={styles.backArrow}>
          <div onClick={navigateBack} style={{ marginRight: "10px" }}>
            <CustomLeftIcon />
          </div>
          <Typography className={styles.heading}>List of Item Added</Typography>
        </div>
        {cartItemsList.length > 0 ? (
          <table className={styles.tableContainer}>
            <thead>
              <tr className={styles.headerTableRow}>
                <th className={styles.tableHorizontal}>Type</th>
                <th className={styles.tableHorizontal}>Priest Name</th>
                {/* <th className={styles.tableHorizontal}>Pooja Title</th> */}
                <th className={styles.tableHorizontal}>Deities</th>
                <th className={styles.tableHorizontal}>Date of Pooja</th>
                <th className={styles.tableHorizontal}>Donation Purpose</th>
                <th className={styles.tableHorizontal}>
                  Suggested Donation Amount
                </th>
                <th className={styles.tableHorizontal}>Tangible Amount</th>
                <th className={styles.tableHorizontal}>Action</th>
              </tr>
            </thead>
            <tbody className={styles.tableBody}>
              {cartItemsList.map((item: cartItemListProps, index: number) => (
                <tr key={index} className={styles.tableRow}>
                  <td className={styles.tableDiagonal}>{item?.type}</td>
                  <td className={styles.tableDiagonal}>{item.priestName}</td>
                  <td className={styles.tableDiagonal}>
                    {item?.deities?.map((diety) => (
                      <>
                        {diety}
                        <br />
                      </>
                    ))}
                  </td>
                  <td className={styles.tableDiagonal}>{item?.dateOfPooja}</td>
                  <td className={styles.tableDiagonal}>
                    {item?.donationPurpose}
                  </td>
                  <td className={styles.tableDiagonal}>
                    {formatAmount(item?.amount)}
                  </td>
                  <td className={styles.tableDiagonal}>
                    {formatAmount(item?.tangibleAmount)}
                  </td>
                  <td className={styles.tableDiagonal}>
                    <img
                      src={deleteIcon}
                      onClick={() => openConfirmPopUp(item?.id)}
                      alt="delete item"
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <p>No Items Selected</p>
        )}
        {cartItemsList.length > 0 && (
          <>
            <div className={styles.totalAmount}>
              <p>Total {formatAmount(totalDonationAmount)}</p>
            </div>
          </>
        )}
      </div>
    );
  };

  const handleClose = () => {
    setIsOpen(false);
    setSelectedId(null);
  };

  const handleAgree = () => {
    if (selectedId !== null) {
      // Find the index of the item with the selected ID in the addedItemsList
      apiRequest({
        method: "DELETE",
        includeToken: true,
        endpoint: `${apiPath.deleteCartItem}/${selectedId}`,
      })
        .then((res) => {
          getCartItems();
          // Close the dialog
          handleClose();
          // toast.custom(<ToastSuccess message={LOCALE.ITEM_DELETED} />)
          toast.custom(
            <SuccessPopup
              headerMessage="Items Deleted"
              showMessage={LOCALE.ITEM_DELETED}
              isOpen={isOpen}
              setIsOpen={setIsOpen}
              
            />,
            {
              duration: constants.TOAST_POPUP_DURATION,
            }
          );
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const dialogPopup = () => {
    return (
      <Dialog
        open={isOpen}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{
          style: {
            height: "calc(100% - 128px)",
            width: "calc(100% - 128px)",
            margin: "64px",
            maxWidth: "504px",
            maxHeight: "180px",
            overflowY: "unset",
            borderTopLeftRadius: "16px",
            borderTopRightRadius: "16px",
          },
        }}
      >
        <DialogTitle className={commonStyles.dialogTitle}>
          {"Please Confirm"}

          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: "absolute",
              right: 24,
              top: 12,
              color: (theme: any) => theme.palette.grey[500],
            }}
          >
            <CloseIcon sx={{ color: "white" }} />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <DialogContentText
            id="alert-dialog-slide-description"
            className={commonStyles.dialogContext}
          >
            Are You Sure want to remove the Item ?
          </DialogContentText>
        </DialogContent>

        <DialogActions>
          <CommonOutlinedButton onClick={handleClose}>No</CommonOutlinedButton>
          <CommonButton onClick={handleAgree}>Yes</CommonButton>
        </DialogActions>
      </Dialog>
    );
  };

  const listComponentAndPayment = () => {
    return (
      <>
        {getHeaders() ? (
          <Typography component="div" className={styles.typoGraphyHeading}>
            Devotee Service
          </Typography>
        ) : (
          ""
        )}
        <div style={{ width: "100%" }}>
          {tableDataComponent()}
          {cartItemsList.length > 0 && <ModeofPayment />}
          {dialogPopup()}
        </div>
      </>
    );
  };

  const handleCart = (): void => {
    if (cartItemsList.length > 0) {
      setShowList(true);
    } else {
      setShowList(false);
    }
  };

  const renderMainComponent = () => {
    return (
      <div className={styles.VastrasContainer} style={{width: `${hasManagerLevelRole? "": "100%"}`}}>
        <div className={styles.formContainer}>
          {getHeaders() ? (
            <Box
              className={styles.headerAndCartContainer}
              sx={{ alignItems: "center", mb: "24px" }}
            >
              <div className={styles.typoGraphyHeading}>
                <Typography
                  className={styles.typoGraphy}
                >
                  Vastra
                </Typography>
              </div>
              <div className={styles.cartContainer}>
                {!isNil(props.onBackClick) && (
                  <CommonOutlinedButton
                    onClick={props.onBackClick}
                    sx={{ marginTop: "10px", marginRight: "10px" }}
                  >
                    Back to Search Devotee
                  </CommonOutlinedButton>
                )}
                <div className={styles.text}>Devotee Cart</div>
                <IconButton aria-label="cart" onClick={handleCart}>
                  <CustomBadge
                    badgeContent={cartItemsList.length}
                    color="secondary"
                  >
                    <img src={cartIcon} alt="cart Icon" />
                  </CustomBadge>
                </IconButton>
              </div>
            </Box>
          ) : (
            ""
          )}
          {!getHeaders() ? (
            <div className={styles.cartContainer}>
              <div className={styles.text}>Devotee Cart</div>
              <IconButton aria-label="cart" onClick={handleCart}>
                <CustomBadge
                  badgeContent={cartItemsList.length}
                  color="secondary"
                >
                  <img src={cartIcon} alt="cart Icon" />
                </CustomBadge>
              </IconButton>
            </div>
          ) : (
            ""
          )}
          <Card className={styles.cardContainer}>
            <div style={{ padding: "24px" }}>
              <Grid container spacing={2}>
                <Grid xs={12} sm={4} item >
                  {CustomRequiredInputLabel("Name", true)}
                  <CustomTextFeild
                  id="name"
                    fullWidth
                    required
                    value={
                      getUserSelectedRole() === constants.MANAGER_ROLE ||
                      getUserSelectedRole() === constants.ADMINSTARTIVE_ASSISTANT_ROLE ||
                      getUserSelectedRole() === constants.FRONT_DESK_ROLE ||
                      getUserSelectedRole() === constants.OFFICE_STAFF_ROLE ||
                      getUserSelectedRole() === constants.FACILITIES_ROLE
                        ? getDevoteeId()?.fullName?.toUpperCase()
                        : getUserDetails()?.toUpperCase()
                    }
                    className={
                      errorMessage.username
                        ? styles.errorTextField
                        : styles.textField
                    }
                    InputProps={{
                      readOnly: true,
                    }}
                  />
                  {errorMessage.username ? (
                    <Typography sx={{ color: "red", fontSize: "12px" }}>
                      {errorMessage.username}
                    </Typography>
                  ) : (
                    ""
                  )}
                </Grid>
              </Grid>
              <Grid container spacing={2} sx={{ marginTop: "5px" }}>
                <Grid xs={12} sm={4} item >
                  {CustomRequiredInputLabel("Purpose of Vastra", true)}
                  {PurposeOfVastrasList()}
                </Grid>
              </Grid>
              <Grid container spacing={2} sx={{ marginTop: "5px" }}>
                <Grid xs={12} sm={4} item >
                  {VastracategoryDropdown()}
                </Grid>
                <Grid xs={12} sm={4} item >
                  {VastraExchangeCheckBoxes()}
                </Grid>
              </Grid>

              <Grid container spacing={2} sx={{ marginTop: "5px" }}>
                <Grid xs={12} sm={4} item>
                  {CustomRequiredInputLabel("Suggested Donation Amount", true)}
                  <CustomTextFeild
                  id="suggestedDonationAmount"
                    fullWidth
                    required
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <AttachMoneyIcon
                            fontSize="small"
                            sx={{ zIndex: "1", position: "absolute" }}
                          />
                        </InputAdornment>
                      ),
                    }}
                    value={formData.amountinDollars}
                    onChange={(e) => {
                      const numericValue = e.target.value.replace(/[^\d.]/g, '').slice(0, 10); // Allow only the first 10 numbers
                      handleFieldChange("amountinDollars", numericValue);
                      setErrorMessage({ ...errorMessage, amountinDollars: "" });
                    }}
                    className={
                      errorMessage.amountinDollars
                        ? styles.errorTextField
                        : styles.textField
                    }
                  />
                  {errorMessage.amountinDollars ? (
                    <Typography sx={{ color: "red", fontSize: "12px" }}>
                      {errorMessage.amountinDollars}
                    </Typography>
                  ) : (
                    ""
                  )}
                </Grid>
                <Grid xs={12} sm={4} item >
                  {CustomRequiredInputLabel("Deity", true)}
                  {DeityDropdown()}
                </Grid>
                {hasManagerLevelRole && (
                  <Grid xs={12} sm={4} item>
                    {CustomRequiredInputLabel("Vastra Tag", false)}
                    <CustomTextFeild
                    id="vastraTag"
                      fullWidth
                      required
                      value={formData.vastraTag}
                      onChange={(e) => {
                        handleFieldChange("vastraTag", e.target.value);
                        setErrorMessage({ ...errorMessage, vastraTag: "" });
                      }}
                      className={
                        errorMessage.vastraTag
                          ? styles.errorTextField
                          : styles.textField
                      }
                    />
                    {errorMessage.vastraTag ? (
                      <Typography sx={{ color: "red", fontSize: "12px" }}>
                        {errorMessage.vastraTag}
                      </Typography>
                    ) : (
                      ""
                    )}
                  </Grid>
                )}
              </Grid>
              <Grid container spacing={2} sx={{ marginTop: "5px" }}>
                <Grid xs={12} sm={4} item >
                  {CustomRequiredInputLabel("Date of Adornment", true)}
                  {BasicDatePicker()}
                </Grid>
                <Grid xs={12} sm={4} item >
                  {CustomRequiredInputLabel("Vigraha Type", true)}
                  {VigrahaDropdown()}
                </Grid>
                <Grid xs={12} sm={4} item>
                  {CustomRequiredInputLabel("Tangible Amount", true)}
                  <CustomTextFeild
                  id="tangibleAmount"
                    fullWidth
                    required
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <AttachMoneyIcon
                            fontSize="small"
                            sx={{ zIndex: "1", position: "absolute" }}
                          />
                        </InputAdornment>
                      ),
                      readOnly: !hasManagerLevelRole,
                    }}
                    value={formData.tangibleAmount}
                    onChange={(e) => {
                      const numericValue = e.target.value
                        .replace(/[^\d.]/g, "")
                        .slice(0, 10); // Allow only the first 10 numbers
                      handleFieldChange("tangibleAmount", numericValue);
                      setErrorMessage({ ...errorMessage, tangibleAmount: "" });
                    }}
                    className={
                      errorMessage.amountinDollars
                        ? styles.errorTextField
                        : styles.textField
                    }
                  />
                  {errorMessage.tangibleAmount ? (
                    <Typography sx={{ color: "red", fontSize: "12px" }}>
                      {errorMessage.tangibleAmount}
                    </Typography>
                  ) : (
                    ""
                  )}
                </Grid>
              </Grid>
              <Grid
                xs={30}
                sm={13}
                item
                sx={{ marginTop: "15px" }}
                
              >
                {CustomRequiredInputLabel("Description", true)}
                <TextareaAutosize
                  id="description"
                  style={{ height: "79px",marginTop:"0" }}
                  required
                  onChange={(e) => {
                    handleFieldChange("description", e.target.value);
                    setErrorMessage({ ...errorMessage, description: "" });
                  }}
                  className={
                    errorMessage.description
                      ? styles.errorTextField
                      : styles.textArea
                  }
                  value={formData.description}
                ></TextareaAutosize>
                {errorMessage.description ? (
                  <Typography sx={{ color: "red", fontSize: "12px" }}>
                    {errorMessage.description}
                  </Typography>
                ) : (
                  ""
                )}
              </Grid>
            </div>
          </Card>
          <CommonButton
            sx={{ marginTop: "10px" }}
            onClick={handleAdd}
            disabled={loading}
            id="add"
          >
            {loading ? (
              <>
                <ClipLoader color="#fff" loading={loading} size={15} />
                <span
                  style={{
                    marginLeft: "8px",
                    fontSize: "15px",
                    textAlign: "center",
                  }}
                >
                  Adding...
                </span>
              </>
            ) : (
              "Add"
            )}
          </CommonButton>
        </div>
      </div>
    );
  };

  return (
    <>
      <Toaster />
      {!showList ? (
        renderMainComponent()
      ) : (
        <CartComponent navigateBack={navigateBack} />
      )}
    </>
  );
};
export default Vastaras;
